/* eslint-disable @typescript-eslint/no-magic-numbers */
import React from 'react'

import { capitalizeASpecificLetter } from '@common/functions'
import { SVGWalletConnect, SVGAlgosigner, SVGArrowRight } from '@common/public/assets'
import { SVGCoinbase, SVGMetamask } from '@common/public/images'
import useNetworkWallet from '@hooks/useNetworkWallet'
import { IWalletsLogos } from '@types'

import { PaymentMethodItem, RowContainer } from './styles'

interface IWalletProvider {
    paymentMethod: string
}

const walletsLogos: IWalletsLogos = {
    metamask: <SVGMetamask />,
    algosigner: <SVGAlgosigner />,
    walletconnect: <SVGWalletConnect />,
    coinbase: <SVGCoinbase />,
}

const WalletProvider: React.FC<IWalletProvider> = ({ paymentMethod }) => {
    const {
        operations: { handleSelectPaymentMethod },
    } = useNetworkWallet()
    return (
        <PaymentMethodItem key={`payment-method-${paymentMethod}`}>
            <button className={paymentMethod} onClick={handleSelectPaymentMethod} value={paymentMethod}>
                <RowContainer>
                    {walletsLogos[paymentMethod]}
                    {paymentMethod === 'walletconnect' ? capitalizeASpecificLetter(paymentMethod, 6) : paymentMethod}
                </RowContainer>
                <SVGArrowRight />
            </button>
        </PaymentMethodItem>
    )
}

export default WalletProvider
